import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, DatePicker, Spin, Table, Switch } from 'antd';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import BaseListing from 'src/BaseListings';
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector';
import { VOUCHER_STATUS_DROPDOWN_OPTIONS } from 'src/models/vouchers';
import WidgetProjectSelector from 'src/widgets/Selectors/WidgetProjectSelector';
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper';
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtFormatMoney } from 'src/helpers/commons/utils';
import WidgetPartySelector from 'src/widgets/Selectors/WidgetPartySelector';
import WidgetAccountsSelectorVirtualized from 'src/widgets/Selectors/WidgetAccountsSelectorVirtualized';
import WidgetEmployeeSelector from 'src/widgets/Selectors/WidgetEmployeeSelector';

const GROPUP_OPTIONS = [
    { value: 1, label: "Party" },
    { value: 2, label: "Project" },
    { value: 3, label: "Employee" }
];

const GroupBalance = () => {
    const Base = new BaseListing('group_balance')
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm();

    const [accounts, setAccounts] = useState([])
    const [projects, setProjects] = useState([])
    const [parties, setParties] = useState([])
    const [employees, setEmployees] = useState([])

    const [accountId, setAccountId] = useState()
    const [accountName, setAccountName] = useState('')
    const [groupId, setGroupId] = useState()
    const [groupName, setGroupName] = useState('')
    const [projectId, setProjectId] = useState()
    const [projectName, setProjectName] = useState('')

    const [voucherStatus, setVoucherStatus] = useState()
    const [voucherStatusName, setVoucherStatusName] = useState('')

    const [group, setGroup] = useState()
    const [groupTypeName, setGroupTypeName] = useState('')

    const [branchId, setBranchId] = useState(0)
    const [branchName, setBranchName] = useState('')
    const [groupBalanceData, setGroupBalanceData] = useState([])
    const [openingBalance, setOpeningBalance] = useState(0)
    const [closingBalance, setClosingBalance] = useState(0)
    const [dateRange, setDateRange] = useState([])

    const [searchMore, setSearchMore] = useState(false)
    const [hideClosingEntries, setHideClosingEntries] = useState(false)
    const [hideZeroBalances, setHideZeroBalances] = useState(true)

    const companyName = wtGetFromLocalStorage("company_name");
    const branches = wtGetFromLocalStorage("branches");

    // Define columns of group balances
    const groupBalancesHeaderColumns = [
        {
            title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>{groupTypeName ? groupTypeName : "Description"}</span>,
            dataIndex: 'name',
            key: 'name',
            align: 'left',
            width: 550,
            render: (text, record) => (
                <span style={{ fontWeight: (record.id === 'total') ? 'bold' : 'normal', fontSize: "0.8rem", cursor: "pointer" }}>
                    {text}
                </span>
            )
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>Opening Balance</span>,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Debit ( .Rs. )</span>,
                    dataIndex: 'opening_balance_debit',
                    key: 'opening_balance_debit',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{ fontWeight: (record.id === 'total') ? 'bold' : 'normal', fontSize: "0.8rem" }}
                        >
                            {getLink(record, text, 'opening')}
                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Credit ( .Rs. )</span>,
                    dataIndex: 'opening_balance_credit',
                    key: 'opening_balance_credit',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{ fontWeight: (record.id === 'total') ? 'bold' : 'normal', fontSize: "0.8rem" }}
                        >
                            {getLink(record, text, 'opening')}
                        </span>
                    ),
                },
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>Current Period</span>,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Debit ( .Rs. )</span>,
                    dataIndex: 'current_period_debit',
                    key: 'current_period_debit',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{ fontWeight: (record.id === 'total') ? 'bold' : 'normal', fontSize: "0.8rem" }}
                        >
                            {getLink(record, text, 'current')}
                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Credit ( .Rs. )</span>,
                    dataIndex: 'current_period_credit',
                    key: 'current_period_credit',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{ fontWeight: (record.id === 'total') ? 'bold' : 'normal', fontSize: "0.8rem" }}
                        >
                            {getLink(record, text, 'current')}
                        </span>
                    ),
                },
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>Closing Balance</span>,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Debit ( .Rs. )</span>,
                    dataIndex: 'closing_balance_debit',
                    key: 'closing_balance_debit',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{ fontWeight: (record.id === 'total') ? 'bold' : 'normal', fontSize: "0.8rem" }}>
                            {getLink(record, text, 'closing')}
                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Credit ( .Rs. )</span>,
                    dataIndex: 'closing_balance_credit',
                    key: 'closing_balance_credit',
                    align: 'right',
                    render: (text, record) => (
                        <span style={{ fontWeight: (record.id === 'total') ? 'bold' : 'normal', fontSize: "0.8rem" }}
                        >
                            {getLink(record, text, 'closing')}
                        </span>
                    ),
                },
            ]
        },
    ];

    const getLink = (record, text, key) => {

        if (dateRange.length < 2) {
            lzNotifyErrorMessageFromResult("Please select date range");
            return;
        }
        if (record.id === 'total') {
            return wtFormatMoney(text, "", false, 2);
        }

        let fromDate = "";
        let toDate = "";

        if (key === 'opening') {
            fromDate = "2000-01-01";
            toDate = (dateRange[0].subtract(1, 'day')).format('YYYY-MM-DD');
        }

        if (key === 'current' || key === 'closing') {
            fromDate = dateRange[0].format('YYYY-MM-DD');
            toDate = dateRange[1].format('YYYY-MM-DD');
        }

        let queryParams = "fromDate=" + fromDate + "&toDate=" + toDate + "&accountId=" + (+accountId) + "&voucherStatus=" + (+voucherStatus) + "&branchId=" + (+branchId) + "&branchName=" + branchName + "&hideClosingEntries=" + (+hideClosingEntries) + "";

        if (+projectId > 0 && +group !== 2) {
            queryParams += "&projectId=" + (+projectId) + "";
        }
        if (+group === 1) {
            queryParams += "&partyId=" + (record.id) + "";
        }
        if (+group === 2) {
            queryParams += "&projectId=" + (record.id) + "";
        }
        if (+group === 3) {
            queryParams += "&employeeId=" + (record.id) + "&employeeName=" + record.name + "";
        }
        return (
            <a href={'/reports?' + queryParams + '#code:account-statement'}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "#000000" }}
            >
                {wtFormatMoney(text, "", false, 2)}
            </a>
        )
    }


    const changeValues = (key, val) => {

        //Set initial values
        setOpeningBalance(0);
        setClosingBalance(0);
        setGroupBalanceData([]);

        if (key === 'branch_id') {
            setBranchId(val.value)
            setBranchName(val.label)
        }
        if (key === 'account_id') {
            setAccountId(val)
            if (val === '') {
                setAccountName('');
            }
        }
        if (key === 'group_item_id') {
            setGroupId(val)
            if (val === '') {
                setGroupName('');
            }
        }
        if (key === 'project_id') {
            setProjectId(val)
            if (val === '') {
                setProjectName('');
            }
        }
        if (key === 'voucher_status') {
            setVoucherStatus(val.value)
            setVoucherStatusName(val.label)
        }
        if (key === 'group') {
            setGroupId()
            setGroupName('')
            setGroup(val.value)
            setGroupTypeName(val.label)
        }
        if (key === 'date_range') {
            setDateRange(val);
        }
        if (key === 'hide_closing_entries') {
            setHideClosingEntries(val);
        }
        if (key === 'hide_zero_balances') {
            setHideZeroBalances(val);
        }

    }

    useEffect(() => {
        Base.dropdownData('accounts,projects,parties,employees', { ignore_last_level: false, enable_all_levels: true }, [setAccounts, setProjects, setParties, setEmployees], 1);
    }, []);


    const getReportData = () => {
        if (dateRange.length < 2) {
            lzNotifyErrorMessageFromResult("Please select date range");
            return;
        }
        const fromDate = dateRange[0];
        const toDate = dateRange[1];

        setIsLoading(true);
        wtApiCall(
            'reports/group_balances',
            {
                branch_id: branchId,
                from_date: fromDate.format('YYYY-MM-DD'),
                to_date: toDate.format('YYYY-MM-DD'),
                account_id: accountId,
                group_id: groupId,
                project_id: +group !== 2 ? projectId : 0,
                voucher_status: voucherStatus,
                hide_closing_entries: hideClosingEntries,
                hide_zero_balances: hideZeroBalances,
                group: group,
            },
            'get',
            (response) => {

                //set data
                if (response !== null) {
                    if (response.data !== null) {
                        if (response.data.length > 0) {
                            setGroupBalanceData(response.data);
                        }
                        else {
                            //Set initial values
                            setGroupBalanceData([]);
                        }
                    }
                }
                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
                setIsLoading(false);
            },
        );

    };


    const exportToExcel = () => {
        setIsLoading(true);
        wtApiPostWithContentTypeHandling('reports/group_balances/export', { opening_balance: openingBalance, data: groupBalanceData, closing_balance: closingBalance });
        setIsLoading(false);
    }


    return (
        <div className='container-fluid' style={{
            padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica",
        }}>
            <Form
                layout={'vertical'}
                form={form}
                onFinish={getReportData}
                style={{ maxWidth: "100%", margin: '0 auto' }}
            >
                <Card title={<span style={{ fontSize: '22px', marginLeft: "40%" }}>{companyName + " Group Balances"}</span>} style={{ width: "100%" }}>

                    <Row gutter={[24, 24]}>
                        <Col xs={15} sm={10} md={5}>
                            <label>Date Range: *</label>
                            <DatePicker.RangePicker
                                onChange={(value) => changeValues('date_range', value)}
                                style={{ width: '100%', height: 35 }}
                                value={dateRange}
                            />
                        </Col>
                        <Col xs={20} sm={16} md={11}>
                            <label className='account_dropdown_label_class'>Account: *</label>
                            <WidgetAccountsSelectorVirtualized
                                data={accounts}
                                value={accountId}
                                displayValue={accountName}
                                height={35}
                                onChange={(value) => changeValues('account_id', value)}
                                reloadDropdownData={() => Base.dropdownData('accounts', {}, [setAccounts], 1)}
                            />
                        </Col>

                        <Col xs={9} sm={6} md={3}>
                            <label>Group By: *</label>
                            <WidgetSelector
                                selectedValue={group}
                                displayValue={groupTypeName}
                                options={GROPUP_OPTIONS}
                                showCloudIcon={false}
                                onChange={(values) => changeValues("group", values)}
                            />
                        </Col>


                        <Col xs={12} sm={8} md={5}>
                            <Button style={{ marginTop: 30, marginRight: 5 }} type="primary" htmlType="submit" disabled={isLoading ? true : false}>Search</Button>
                            <Button style={{ marginTop: 30, marginRight: 5, color: "#fff", backgroundColor: "#E29C06" }} onClick={() => setSearchMore(!searchMore)} disabled={isLoading ? true : false}>{searchMore ? "Less..." : "More..."}</Button>
                            <Button style={{ marginTop: 30, backgroundColor: "#4BB543", color: "#fff" }} onClick={exportToExcel} disabled={isLoading ? true : false}>Export</Button>
                        </Col>


                    </Row>

                    {searchMore && (
                        <Row gutter={[24, 24]}>
                            <Col xs={12} sm={8} md={5}>
                                <label>Voucher Status: </label>
                                <WidgetSelector
                                    selectedValue={voucherStatus}
                                    displayValue={voucherStatusName}
                                    options={VOUCHER_STATUS_DROPDOWN_OPTIONS}
                                    showCloudIcon={false}
                                    onChange={(values) => changeValues("voucher_status", values)}
                                />
                            </Col>
                            <Col xs={12} sm={8} md={5}>
                                <label>Branch:</label>
                                <WidgetBranchSelector
                                    value={branchId}
                                    displayValue={branchName}
                                    branches={branches}
                                    placeholder="Select Branch"
                                    onChange={(values) => changeValues('branch_id', values)}
                                    showCloudIcon={false}
                                />

                            </Col>

                            {(+group === 2) &&
                                <Col xs={12} sm={8} md={6}>
                                    <label>Project: </label>
                                    <WidgetProjectSelector
                                        onChange={(value) => changeValues('group_item_id', value)}
                                        data={projects}
                                        value={groupId}
                                        displayValue={groupName}
                                        height={35}
                                        reloadDropdownData={() => Base.dropdownData('projects', {}, [setProjects], 1)}
                                    />
                                </Col>
                            }
                            {(+group === 1) &&
                                <Col xs={18} sm={12} md={6}>
                                    <label>Party: </label>
                                    <WidgetPartySelector
                                        onChange={(value) => changeValues("group_item_id", value)}
                                        parties={parties}
                                        displayValue={groupName}
                                        value={groupId}
                                        reloadDropdownData={() => Base.dropdownData('parties', {}, [setParties], 1)}
                                    />
                                </Col>
                            }

                            {(+group === 3) &&
                                <Col xs={12} sm={6} md={6}>
                                    <label>Employee:</label>
                                    <WidgetEmployeeSelector
                                        onChange={(value) => changeValues("group_item_id", value)}
                                        employees={employees}
                                        displayValue={groupName}
                                        value={groupId}
                                        showCloudIcon={true}
                                    />
                                </Col>
                            }
                            {(+group !== 2) &&
                                <Col xs={12} sm={8} md={6}>
                                    <label>Project:</label>
                                    <WidgetProjectSelector
                                        onChange={(value) => changeValues('project_id', value)}
                                        data={projects}
                                        value={projectId}
                                        displayValue={projectName}
                                        height={35}
                                        reloadDropdownData={() => Base.dropdownData('projects', {}, [setProjects], 1)}
                                    />
                                </Col>
                            }

                            <Col xs={9} sm={6} md={3}>
                                <label>Hide Closing Entries:</label>
                                <Switch style={{ marginTop: 15 }} value={hideClosingEntries} onChange={(value) => changeValues('hide_closing_entries', value)} />
                            </Col>

                            <Col xs={9} sm={6} md={3}>
                                <label>Hide Zero Balances:</label>
                                <Switch style={{ marginTop: 15 }} value={hideZeroBalances} onChange={(value) => changeValues('hide_zero_balances', value)} />
                            </Col>

                        </Row>
                    )}

                    <br />
                    <div style={{ width: "100%" }}>
                        <Table
                            columns={groupBalancesHeaderColumns}
                            dataSource={groupBalanceData}
                            pagination={false}
                            bordered
                            size="small"
                            scroll={{ y: 400 }}
                            // virtual={true}
                            loading={{ indicator: <div><Spin /></div>, spinning: isLoading }}
                        />
                    </div>
                </Card>
            </Form>
        </div >
    );
};

export default GroupBalance;
